import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description ShieldLock icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { ShieldLock } from '@sravni/design-system-icons'
 *
 * <ShieldLock />
 * ```
 */
var ShieldLock = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "ShieldLock", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M11.43 12.792c0 .79-.64 1.428-1.43 1.428-.789 0-1.448-.639-1.448-1.428l.02-1.812A2.856 2.856 0 0 1 10 5.65a2.857 2.857 0 0 1 1.429 5.331v1.812Z", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10" }),
    React.createElement("path", { d: "M17.143 9.278c0 4.16-2.819 8.06-6.678 9.225a1.607 1.607 0 0 1-.929 0c-3.86-1.165-6.679-5.065-6.679-9.225V5.442c0-.773.439-1.47 1.11-1.763L8.31 1.784a4.203 4.203 0 0 1 3.381 0l4.343 1.895c.67.292 1.11.99 1.11 1.763v3.836Z", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10", strokeLinejoin: "round" }))); });

export { ShieldLock };
//# sourceMappingURL=ShieldLock.js.map
